import { clone } from 'lodash';

const state = {
  allPanelsOpen: false,
  openPanels: new Set(),
};

const getters = {
  isOpen: state => id => {
    return state.allPanelsOpen || !!state.openPanels.has(id);
  },
};

const mutations = {
  SET_OPEN_PANELS(state, ids) {
    state.openPanels = new Set(ids);
  },
  OPEN_ALL_PANELS(state) {
    state.allPanelsOpen = true;
  },
  RESET_PANELS(state) {
    state.allPanelsOpen = false;
    state.openPanels = new Set();
  },
  OPEN_PANEL(state, plannedJobId) {
    let n = clone(state.openPanels);
    n.add(plannedJobId);
    state.openPanels = n;
  },
  CLOSE_PANEL(state, plannedJobId) {
    let n = clone(state.openPanels);
    n.delete(plannedJobId);
    state.openPanels = n;
  },
};

const actions = {
  setOpenPanels({ commit }, ids) {
    commit('SET_OPEN_PANELS', ids);
  },
  togglePanel({ commit, getters }, plannedJobId) {
    if (getters.isOpen(plannedJobId)) {
      commit('CLOSE_PANEL', plannedJobId);
    } else {
      commit('OPEN_PANEL', plannedJobId);
    }
  },
  toggleAllPanels({ commit, state }) {
    if (state.allPanelsOpen) {
      commit('RESET_PANELS');
    } else {
      commit('OPEN_ALL_PANELS');
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
